// extracted by mini-css-extract-plugin
export default {"container":"ContactMap_container__zp3kY","mapcontainer":"ContactMap_mapcontainer__TcPMv","largermap":"ContactMap_largermap__jAg6x","mapSize":"ContactMap_mapSize__JtdeN"};